export default __webpack_public_path__ + "static/media/rest.19575d99.png";